import React from "react";

const Home = () => {
  return (
    <header className="section header" id="header">
      <div className="header-container">
        <h1>francesco</h1>
        <a href="tel:+00 0 000 0000">
          <i className="fa-solid fa-phone"></i> call now +43 681 123 0000
        </a>
      </div>
    </header>
  );
};

export default Home;
